import { z } from "zod";
import { CHAIN_STRATEGY_VALUES } from "../../constants/chain-strategy.js";
import { SHOT_ACTION_MAX_LENGTH, SHOT_PURPOSE_MAX_LENGTH, SHOT_VOICEOVER_MAX_LENGTH } from "../../constants/limits.js";
import { RENDER_MODE_VALUES } from "../../constants/render-mode.js";
export const ShotSchema = z.object({
    id: z.uuid(),
    nodeId: z.uuid(),
    orderIndex: z.number().int().nonnegative(),
    purpose: z.string().min(1).max(SHOT_PURPOSE_MAX_LENGTH),
    action: z.string().min(1).max(SHOT_ACTION_MAX_LENGTH),
    endAction: z.string().min(1).max(SHOT_ACTION_MAX_LENGTH).nullable(),
    durationSeconds: z.number().positive(),
    locationId: z.uuid().nullable(),
    characterIds: z.array(z.uuid()),
    renderMode: z.enum(RENDER_MODE_VALUES),
    chainStrategy: z.enum(CHAIN_STRATEGY_VALUES),
    voiceoverText: z.string().max(SHOT_VOICEOVER_MAX_LENGTH).nullable(),
    startFrameKey: z.string().nullable(),
    endFrameKey: z.string().nullable(),
    videoKey: z.string().nullable(),
});
export const GraphShotSchema = ShotSchema.omit({ startFrameKey: true, endFrameKey: true, videoKey: true });
